export default class RemoteQuery {
    constructor(private query) { }

    includeTags(tagIds: string[]) {
        if (tagIds && tagIds.length) {
            if (!this.query['$and']) {
                this.query['$and'] = [];
            }

            this.query['$and'].push({
                '_searchIdx.tagIds': {
                    $containsAny: tagIds
                }
            });
        }
    }

    excludeTags(tagIds: string[]) {
        if (tagIds && tagIds.length) {
            if (!this.query['$and']) {
                this.query['$and'] = [];
            }

            this.query['$and'].push({
                '_searchIdx.tagIds': {
                    $containsNone: tagIds
                }
            });
        }
    }

    get() {
        return this.query;
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/RemoteQuery.ts